const Header = {
  handleMenuDesktop: function () {
    let $menu_desktop = $('.main-menu');
    let $newsletter_bar = $('.newsletter-bar');
    // handle open
    $('[data-menu-open]').on('click', () => {
      $menu_desktop.addClass('active');
      $newsletter_bar.addClass('menu-active');
    });
    // handle close
    $('[data-menu-close]').on('click', () => {
      $menu_desktop.removeClass('active');
      $newsletter_bar.removeClass('menu-active');
    });
    // handle submenu

    let menusWithSubmenus = document.querySelectorAll('[data-target-submenu]')

    menusWithSubmenus.forEach((menu)=>{
      menu.addEventListener('click', ()=>{
        let getTargetSubmenu = menu.getAttribute('data-target-submenu')
        let submenuTargetEl = document.getElementById(getTargetSubmenu)
        submenuTargetEl.classList.toggle('active')
      })
    })
  },
  setSubSubmenuDesktop: function(){
    $(".wrapper-menus .has-submenu").on("mouseover", function(e){
      $(this).find(".wrapper-subsubmenu").slideDown()
    })
    $(".wrapper-menus .menu").on("mouseleave", function(e){
      $(".wrapper-subsubmenu").slideUp()
    })
  },
  setSliderRotateBar: function() {
    const resolution = $('body').width() > 767 ? 'desktop' : 'mobile'
    let autoplay = {};
    let effect = '';

    if (resolution == 'mobile') {
      autoplay =  {
        delay: 4000
      },
      effect =  'fade'
    } else {
      autoplay =  false
    }
    
    const rotateBarSwiper = new Swiper($('[data-rotate-bar]'), {
      watchOverflow: true,
      slidesPerView: 1,
      centerInsufficientSlides: true,
      spaceBetween: 0,
      navigation: {
        nextEl: $('[data-rotate-bar]').find('.swiper-button-next'),
        prevEl: $('[data-rotate-bar]').find('.swiper-button-prev'),
      }
    });
  },
  setSliderRotateMobileBar: function() {
    const rotateBarSwiper = new Swiper($('[data-rotate-mobile-bar]'), {
      watchOverflow: true,
      slidesPerView: 1,
      centerInsufficientSlides: true,
      spaceBetween: 0,
      speed: 2000,
      autoplay: {
        delay: 3000
      },
      effect: 'fade'
    });
  },
  setSliderRotateDesktopBar: function() {
    const rotateBarSwiper = new Swiper($('[data-rotate-desktop-bar]'), {
      watchOverflow: true,
      slidesPerView: 1,
      centerInsufficientSlides: true,
      spaceBetween: 0,
      speed: 2000,
      autoplay: {
        delay: 3000
      },
      effect: 'fade'
    });
  },
  init: function(){
    const _this = this;

    _this.handleMenuDesktop();
    _this.setSubSubmenuDesktop();

    _this.setSliderRotateBar();
    _this.setSliderRotateMobileBar();
    _this.setSliderRotateDesktopBar();
  }
}

export default Header
